import { Component, ViewChild } from "@angular/core";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { DxDataGridComponent, DxListComponent, DxSelectBoxComponent, DxTagBoxComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { Observable, forkJoin, of } from 'rxjs';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { environment } from "src/environments/environment";
import { TgeeASUManufacturerReportService } from "./tgee-asu-map-manufacturer.service";

@Component({
    selector: 'smr-and-asu-awards-report',
    templateUrl: 'tgee-asu-map-manufacturer.html',
    styleUrls: ['tgee-asu-map-manufacturer.scss']
})

export class TGEEASUManufacturerReportComponent {
    smrAndAsuAwardsReportFilterData: any[];
    countryDataSource: any[];
    manufacturerDataSource: any[];
    filteredManufacturerDataSource: any[];
    filteredAsuManufacturerDataArray: any[];
    filteredAsuManufacturerMapArray: any[];
    selectedCountry: string;
    selectedCountryResult: string;
    provinceDataSource: any;
    selectedManufacturers: string[];
    gasDataSource: any[];
    selectedGas: any;
    reportDataSource: any[];
    asuManufacturerDataResponse: any[];
    asuManufacturerMapDataResponse: any[];
    asuAwardsReportDataSource: any[];
    mapMarkers: any = [];
    markers: any[] = [];
    asuAwardsReportMarkers: any[];
    colors: any[];
    asuAwardsReportcolors: any[];
    n2Size: any[];
    o2Size: any[];
    asuAwardsReportSize: any[];
    map: google.maps.Map;
    infoWindow: google.maps.InfoWindow;
    asuAwardsData: Observable<any[]> = of([]);
    addASUAwards: boolean = false;

    @ViewChild('manufacturerslist', { static: false }) manufacturers: DxListComponent;
    @ViewChild("country", { static: false }) country: DxSelectBoxComponent;
    @ViewChild("gas", { static: false }) gas: DxTagBoxComponent;
    @ViewChild("ASUFacilitiesGrid", { static: false }) asuFacilitiesGrid: DxDataGridComponent;

    isLoadPanelVisible: boolean = false;

    constructor(private notificationService: NotificationService, private tgeeASUManufacturerReportService: TgeeASUManufacturerReportService) {

        this.isLoadPanelVisible = true;
        this.getReportsData();
    }

    onCountryChanged(e) {
        if (e.value && e.value.length > 0) {
            this.filteredManufacturerDataSource = this.asuManufacturerDataResponse.filter((item) => e.value.indexOf(item.country) >= 0).map((item) => ({ manufacturer: item.manufacturer })).filter((value, index, self) => self.findIndex((s) => value.manufacturer === s.manufacturer) === index).sort();
            this.selectedManufacturers = this.filteredManufacturerDataSource.map(item => item.manufacturer);
        } else {
            this.filteredManufacturerDataSource = [];
            this.selectedManufacturers = [];
        }
    }

    onManufacturersListSelectionChanged(e) {
        this.selectedManufacturers = this.manufacturers.selectedItemKeys;
    }

    exportExcel(e) {
        this.asuFacilitiesGrid.instance.columnOption('siteId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.asuFacilitiesGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASUManufacturerByCountry.xlsx');
                });
        }).then(() => {
            this.asuFacilitiesGrid.instance.columnOption('siteId', 'visible', false);   
        });
        e.cancel = true;
    }

    getReportsData() {
        this.isLoadPanelVisible = true;
        var asuManufacturerData = this.tgeeASUManufacturerReportService.getAsuManufacturerReportData();
        var asuManufacturerMapData = this.tgeeASUManufacturerReportService.getAsuManufacturerMapData();

        forkJoin([asuManufacturerData, asuManufacturerMapData]).subscribe(([asuManufacturerDataArray, asuManufacturerMapDataArray]) => {
            const contentDivBlock = document.getElementById("contentDiv") as HTMLElement;            
            contentDivBlock.hidden = true;

            this.asuManufacturerDataResponse = asuManufacturerDataArray;
            this.asuManufacturerMapDataResponse = asuManufacturerMapDataArray;
            this.filteredAsuManufacturerMapArray = asuManufacturerMapDataArray;
            this.manufacturerDataSource = asuManufacturerDataArray.map((item) => item.manufacturer).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.selectedGas = this.gasDataSource = asuManufacturerDataArray.map((item) => item.gas).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);

            this.countryDataSource = asuManufacturerDataArray.map((item) => item.country).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.isLoadPanelVisible = false;
        });
    }

    populateData(): void {
        if (!this.selectedCountry || this.selectedCountry.length <= 0 || !this.selectedManufacturers
            || this.selectedManufacturers.length <= 0 || !this.selectedGas || this.selectedGas.length <= 0) {
            if (!this.selectedCountry) this.country.validationStatus = "invalid";
            if (!this.selectedGas) this.gas.validationStatus = "invalid";
            return;
        }
        this.filteredAsuManufacturerDataArray = this.asuManufacturerDataResponse.filter((item) => this.selectedCountry.indexOf(item.country) >= 0
            && this.selectedManufacturers.some((val) => val === item.manufacturer) && this.selectedGas.some((val) => val === item.gas));
        this.filteredAsuManufacturerMapArray = this.asuManufacturerMapDataResponse.filter((item) => this.selectedCountry.indexOf(item.country) >= 0
            && this.selectedManufacturers.some((val) => val === item.manufacturer) && this.selectedGas.some((val) => val === item.gas));

            const contentDivBlock = document.getElementById("contentDiv") as HTMLElement;            
            

        if (this.filteredAsuManufacturerDataArray && this.filteredAsuManufacturerDataArray.length > 0) {
            contentDivBlock.hidden = false;
            this.selectedCountryResult = this.selectedCountry;

        } else {
            contentDivBlock.hidden = true;
            return;
        }

        this.asuAwardsReportcolors = [];
        this.n2Size = [];
        this.o2Size = [];
        this.markers = [];

        this.markers = this.filteredAsuManufacturerMapArray.map(item => item).sort((a, b) => b.gasQuantity - a.gasQuantity);
        this.colors = this.filteredAsuManufacturerMapArray.map(item => <any>{ technologyProviderColor: item.color, technologyProvider: item.manufacturer })
            .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => (a.manufacturer > b.manufacturer ? 1 : -1));
        this.n2Size = this.filteredAsuManufacturerMapArray.filter(a => a.gas == 'Nitrogen').map(item => <any>{
            h2Size: item.ranges.split(',')[1],
            h2SizeRange: item.ranges.split(',')[0]
        }).sort((a, b) => a.h2Size - b.h2Size);

        this.o2Size = this.filteredAsuManufacturerMapArray.filter(a => a.gas == 'Oxygen').map(item => <any>{
            h2Size: item.ranges.split(',')[1],
            h2SizeRange: item.ranges.split(',')[0]
        }).sort((a, b) => a.h2Size - b.h2Size);

        this.initMap();
        this.isLoadPanelVisible = false;
    }

    initMap(): void {

        const loader = new Loader({
            apiKey: environment.gmaps,
            version: 'weekly'
        });

        loader.load().then((google) => {
            this.mapMarkers = [];
            this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
                center: {
                    lat: this.markers && this.markers.length > 0 ? this.markers[0].latitude : null,
                    lng: this.markers && this.markers.length > 0 ? this.markers[0].longitude : null
                },
                zoom: 4,
                mapTypeId: 'roadmap'
            });

            this.infoWindow = new google.maps.InfoWindow();
            const techProviderLegend = document.getElementById("techProviderLegend") as HTMLElement;

            if (this.colors.length > 0) {
                techProviderLegend.hidden = false;
                techProviderLegend.innerHTML = "";
                techProviderLegend.innerHTML = '<b>Color = Tech Provider</b><hr/>'
            } else {
                techProviderLegend.hidden = true;
            }


            const sizeLegendN2 = document.getElementById("sizeLegendN2") as HTMLElement;
            if (this.n2Size.length > 0) {
                sizeLegendN2.hidden = false;
                sizeLegendN2.innerHTML = "";
                sizeLegendN2.innerHTML = '<b>Size = Nitrogen</b><hr/>';
            } else {
                sizeLegendN2.hidden = true;
            }

            const sizeLegendO2 = document.getElementById("sizeLegendO2") as HTMLElement;
            if (this.o2Size.length > 0) {
                sizeLegendO2.hidden = false;
                sizeLegendO2.innerHTML = "";
                sizeLegendO2.innerHTML = '<b>Size = Oxygen</b><hr/>';
            } else {
                sizeLegendO2.hidden = true;
            }

            let colorcodes = [];

            this.colors.forEach((item, index) => {
                if (colorcodes.indexOf(item.technologyProvider) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="20" width="40">  <circle cx="15" cy="12" r="' + 8 + '" stroke-width="3" fill="' + item.technologyProviderColor + '" /> </svg>' + item.technologyProvider.replace("<", "&lt;");
                    techProviderLegend.appendChild(div);
                    colorcodes.push(item.technologyProvider);
                }
            });

            colorcodes = [];

            let uniqueSizeN2 = [];

            this.n2Size.forEach((item, index) => {
                if (item.h2Size && uniqueSizeN2.indexOf(item.h2Size) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="40" width="40">  <circle cx="20" cy="20" r="' + item.h2Size + '" stroke-width="3" class="blue-circle" /> </svg>' + item.h2SizeRange;
                    sizeLegendN2.appendChild(div);
                    uniqueSizeN2.push(item.h2Size)
                }
            })

            let uniqueSizeO2 = [];

            this.o2Size.forEach((item, index) => {
                if (item.h2Size && uniqueSizeO2.indexOf(item.h2Size) < 0) {
                    const div = document.createElement("div");
                    //div.innerHTML = '<svg height="40" width="40">  <circle cx="20" cy="20" r="' + item.h2Size + '" stroke-width="3" class="blue-circle" /> </svg>' + item.h2SizeRange;
                    div.innerHTML = '<svg width="80" height="70" style="scale: ' + Number.parseFloat(item.h2Size) * 0.07 * 100 + '%;">  <path class="blue-circle" d="M 20,5 40,57.5 1,57.5 z"/> </svg>' + item.h2SizeRange;
                    sizeLegendO2.appendChild(div);
                    uniqueSizeO2.push(item.h2Size)
                }
            })


            for (let i of this.markers) {
                const tempMarker = new google.maps.Marker({
                    position: { lat: i.latitude, lng: i.longitude }, icon: {
                        path: i.gas == 'Nitrogen' ? google.maps.SymbolPath.CIRCLE : "M 20,5 40,57.5 1,57.5 z",
                        scale: i.gas == 'Nitrogen' ? i.ranges && i.ranges.length > 0 ? i.ranges.split(',')[1] - 3 : 7 :
                            i.ranges && i.ranges.length > 0 ? Number.parseFloat(i.ranges.split(',')[1]) * 0.07 : 0.2,
                        fillOpacity: 1,
                        strokeColor: i.color,
                        fillColor: i.color
                    }, map: this.map
                });
                tempMarker.addListener('mouseover', ((tempMarker, map, infoWindow) => {
                    return () => {
                        infoWindow.setContent('<p>' + i.manufacturerGas.replace("<", "&lt;") + ', ' + i.city + ', ' + i.gasQuantity + '</p>');
                        infoWindow.open(map, tempMarker);
                    }
                })(tempMarker, this.map, this.infoWindow));

                tempMarker.addListener('mouseout', ((tempMarker, map, infoWindow) => {
                    return () => {

                        infoWindow.close();
                    }
                })(tempMarker, this.map, this.infoWindow));

                this.mapMarkers.push(tempMarker);
            }

            new MarkerClusterer({ map: this.map, markers: this.mapMarkers });
        });
    }
}